import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent,
  HttpResponse, HttpUserEvent, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { TokenStorageService } from './token-storage.service';
import { map } from 'rxjs/operators';

const TOKEN_HEADER_KEY = 'Authorization';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService {

  constructor(
    private token: TokenStorageService,
    private router: Router
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {

    let authReq = req;
    
    if (authReq.url.endsWith('/user/signon') || (authReq.url.indexOf('/forgetPassword') >= 0) || 
      (authReq.url.indexOf('/resetPassword') >= 0) || authReq.url.endsWith('/change-password') || this.token.getToken() != null){
      if(this.token.getToken() != null && !authReq.url.includes('https://asg-iforms-testdata.s3.amazonaws.com')) {
        req = req.clone({
          setHeaders: {
            Authorization: window.sessionStorage.getItem('AuthorizationD'),
            JSESSIONID: window.sessionStorage.getItem('JSESSIONID'),
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            Pragma: 'no-cache',
            'X-Content-Type-Options': 'nosniff'
          }
        });

        // Pass the cloned request instead of the original request to the next handle
        return next.handle(req).pipe(
          map((event: HttpEvent<any>) => {
            if (event instanceof HttpErrorResponse) {
              if (event.status === 401) {
                this.router.navigate(['']);
              }
            } else {
              if (event instanceof HttpResponse) {
               this.setAuthHeaders(event);
              }
            }
            return event;
          }));
      } else {        
        return next.handle(authReq).pipe(
          map((event: HttpEvent<any>) => {
            if (event instanceof HttpErrorResponse) {
              if (event.status === 401) {
                this.router.navigate(['']);
              }
            } else {
              if (event instanceof HttpResponse) {
                this.setAuthHeaders(event);
              }
            }
            return event;
          }));
      }
    } else if (this.token.getToken() == null) {
      if (authReq.url.includes('transcriber-sso')) {
        return next.handle(authReq).pipe(
          map((event: HttpEvent<any>) => {
            return event;
          }));
      }      
      if (JSON.parse(localStorage.getItem('ssoData')).sso_enabled === "true") {
        let traceid = localStorage.getItem('asgTraceid');
        if(!(traceid && traceid.length>0)){
          traceid = '';
        }
        authReq = authReq.clone({
          setHeaders: {
            Authorization: localStorage.getItem('AuthorizationD'),
            JSESSIONID: localStorage.getItem('JSESSIONID'),
            'x-asg-traceid': traceid
          }
        });

        return next.handle(authReq).pipe(
          map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              this.setAuthHeaders(event);
            }
            return event;
          }));
      }
      this.router.navigate(['']);
    }
  }

  private setAuthHeaders(event: HttpResponse<any>) {
    let header = event.headers;
    let allAuth = header.getAll('Authorization');
    let allJSessionID = header.getAll('jsessionid');
    if(allAuth){
      window.sessionStorage.setItem('AuthorizationD', allAuth[0]);
      window.sessionStorage.setItem('JSESSIONID', allJSessionID[0]);
      localStorage.setItem('AuthorizationD', allAuth[0])
      localStorage.setItem('JSESSIONID', allJSessionID[0])
      this.token.saveToken(allJSessionID);
    }
  }
}
